module.exports = __webpack_public_path__ + "static/intro-0f52969b20af08913f4a32906b9c4a36.mp4";